// extracted by mini-css-extract-plugin
export default {"wrapper":"rkGnLdjjezJv8WQ9N_SX","titleWrapper":"Ndy8L22Viumys_4xacxz","lottieAnimation":"CBYdDLq65xCQdf3tnhSv"};